// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  adapted from:
  https: //piccalil.li/blog/a-modern-css-reset/
  https://www.joshwcomeau.com/css/custom-css-reset/
*/
html,
body {
  height: 100%;
}
header-app-root > section {
  border-bottom-color: white !important;
}
body {
  margin: 0;
  padding: 0;
}
app-root {
  height: 100%;
  isolation: isolate;
  line-height: 1.5;
  text-rendering: optimizeSpeed;
  -webkit-font-smoothing: antialiased;
  display: block;
  min-width: 320px;
  /* Remove list styles on ul, ol elements with a list role due to webkit semantic issues */
}
app-root *,
app-root *::before,
app-root *::after {
  box-sizing: border-box;
}
app-root h1,
app-root h2,
app-root h3,
app-root h4,
app-root p,
app-root figure,
app-root blockquote,
app-root ul,
app-root ol,
app-root dl,
app-root dd,
app-root menu,
app-root fieldset,
app-root input,
app-root button,
app-root a {
  margin: 0;
  padding: 0;
}
app-root ul[role='list'],
app-root ol[role='list'],
app-root menu[role='list'] {
  list-style: none;
}
app-root ul[role='list'] li,
app-root ol[role='list'] li,
app-root menu[role='list'] li {
  display: inline-block;
}
app-root label {
  display: inline-block;
}
app-root:focus-within {
  scroll-behavior: smooth;
}
app-root img,
app-root picture {
  display: block;
  max-width: 100%;
  height: auto;
}
app-root input,
app-root button,
app-root textarea,
app-root select {
  font: inherit;
}
app-root fieldset {
  border: none;
}
app-root p,
app-root h1,
app-root h2,
app-root h3,
app-root h4,
app-root h5,
app-root h6,
app-root li,
app-root dl,
app-root dt,
app-root blockquote {
  overflow-wrap: break-word;
}
@media (prefers-reduced-motion: reduce) {
  app-root *,
  app-root *::before,
  app-root *::after {
    animation: none !important;
    transition: none !important;
  }
  app-root:focus-within {
    scroll-behavior: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/modest-reset.less"],"names":[],"mappings":"AAAA;;;;CAIC;AACD;;EAEE,YAAA;AACF;AAEA;EACE,qCAAA;AAAF;AAGA;EACE,SAAA;EACA,UAAA;AADF;AAIA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,mCAAA;EACA,cAAA;EACA,gBAAA;EAFA,yFAAyF;AAC3F;AANA;;;EAYI,sBAAA;AADJ;AAXA;;;;;;;;;;;;;;;;EA+BI,SAAA;EACA,UAAA;AAFJ;AA9BA;;;EAuCI,gBAAA;AAJJ;AAnCA;;;EA0CM,qBAAA;AAFN;AAxCA;EA+CI,qBAAA;AAJJ;AAOE;EACE,uBAAA;AALJ;AA9CA;;EAwDI,cAAA;EACA,eAAA;EACA,YAAA;AANJ;AApDA;;;;EAiEI,aAAA;AAPJ;AA1DA;EAqEI,YAAA;AARJ;AA7DA;;;;;;;;;;;EAmFI,yBAAA;AATJ;AAYE;EAAA;;;IAII,0BAAA;IACA,2BAAA;EAVJ;EAYE;IACE,qBAAA;EAVJ;AACF","sourcesContent":["/*\n  adapted from:\n  https: //piccalil.li/blog/a-modern-css-reset/\n  https://www.joshwcomeau.com/css/custom-css-reset/\n*/\nhtml,\nbody {\n  height: 100%;\n}\n\nheader-app-root > section {\n  border-bottom-color: white !important;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n}\n\napp-root {\n  height: 100%;\n  isolation: isolate;\n  line-height: 1.5;\n  text-rendering: optimizeSpeed;\n  -webkit-font-smoothing: antialiased;\n  display: block;\n  min-width: 320px;\n\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  p,\n  figure,\n  blockquote,\n  ul,\n  ol,\n  dl,\n  dd,\n  menu,\n  fieldset,\n  input,\n  button,\n  a {\n    margin: 0;\n    padding: 0;\n  }\n\n  /* Remove list styles on ul, ol elements with a list role due to webkit semantic issues */\n  ul[role='list'],\n  ol[role='list'],\n  menu[role='list'] {\n    list-style: none;\n\n    li {\n      display: inline-block;\n    }\n  }\n\n  label {\n    display: inline-block;\n  }\n\n  &:focus-within {\n    scroll-behavior: smooth;\n  }\n\n  img,\n  picture {\n    display: block;\n    max-width: 100%;\n    height: auto;\n  }\n\n  input,\n  button,\n  textarea,\n  select {\n    font: inherit;\n  }\n\n  fieldset {\n    border: none;\n  }\n\n  p,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  li,\n  dl,\n  dt,\n  blockquote {\n    overflow-wrap: break-word;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    *,\n    *::before,\n    *::after {\n      animation: none !important;\n      transition: none !important;\n    }\n    &:focus-within {\n      scroll-behavior: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
